<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules"  label-position="top">
                <Row :gutter="32">
                    <Col span="24">
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 合同签订信息</template>
                            <Row :gutter="32">
                                <Col span="12">
                                    <FormItem label="合同金额" prop="contract_money">
                                        <Input v-model="Forms.contract_money" type="number"  clearable placeholder="如：10000" />
                                    </FormItem>
                                </Col>
                                <Col span="12">
                                    <FormItem label="项目实际金额" prop="money">
                                        <Input v-model="Forms.money" type="number"  clearable placeholder="如：10000" />
                                    </FormItem>
                                </Col>
                                <Col span="12">
                                    <FormItem label="签订人" prop="contract_signa_name">
                                        <Input v-model="Forms.contract_signa_name" clearable placeholder="如：张三+电话" />
                                    </FormItem>
                                </Col>
                                <Col span="12">
                                    <FormItem label="合同有效期" prop="signa_time">
                                        <DatePicker type="daterange" format="yyyy-MM-dd" v-model="Forms.signa_time" placement="bottom-end" placeholder="合同有效期" class="width-100"  />
                                    </FormItem>
                                </Col>
                                <Col span="24">
                                    <FormItem label="合同资料" prop="contract_file">
                                        <Input v-model="Forms.contract_file" disabled>
                                            <template #append>
                                                <div class="f-center">
                                                    <Upload
                                                        :show-upload-list="false"
                                                        :action="upload_url"
                                                        :headers = "{'token': $store.state.token}"
                                                        :format="['xls','xlsx','rar','zip','doc','docx','txt','docx','jpg','jpeg','png']"
                                                        :max-size="50 * 1024"
                                                        :on-success="handleSuccess"
                                                        :on-format-error="handleFormatError"
                                                        :on-exceeded-size="handleMaxSize">
                                                        <a href="javascript:void(0);" class="text-primary"><Icon type="md-cloud-upload" />上传</a>
                                                    </Upload>
                                                    <Divider type="vertical" />
                                                    <a href="javascript:void(0);" @click="FileDelete()" class="text-danger"><Icon type="md-trash" />删除</a>
                                                    <Divider type="vertical" />
                                                    <a href="javascript:void(0);" @click="FileDownload()" class="text-violet"><Icon type="md-download" />下载</a>
                                                </div>
                                            </template>
                                        </Input>
                                    </FormItem>
                                </Col>
                                <Col span="24">
                                    <FormItem label="备注信息" prop="remark">
                                        <Input v-model="Forms.remark" type="textarea" :rows="8" clearable placeholder="备注信息" />
                                        <small class="text-danger">提示：请勿删除原有备注信息</small>
                                    </FormItem>
                                </Col>
                            </Row>

                        </Card>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">确认签订</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {contractProject, getProjectContentDetail} from "@/apis/project";

export default {
    name: 'ProjectContract',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '签订合同',
            isBox : false,
            detail: [],
            upload_url : this.$uploadFileApi,
            site_url : this.$siteApi,
            Forms : {
                project_id: '',
                contract_money: '',
                money: '',
                contract_signa_name: '',
                signa_time: [],
                contract_file: '',
                remark: '',
            },
            Rules : {
                contract_money: [
                    { required: true, type: 'number',  message: '请输入合同金额', trigger: 'blur',  transform(value) { return parseFloat(value)}},
                    { type: 'number', min: 1, message: '合同金额必须大于等于1元', trigger: 'blur' }
                ],
                money: [
                    { required: true, type: 'number',  message: '请输入项目实际金额', trigger: 'blur',  transform(value) { return parseFloat(value)}},
                    { type: 'number', min: 1, message: '项目实际金额必须大于等于1元', trigger: 'blur' }
                ],
                contract_signa_name: [
                    { required: true, message: '请输入签订人信息 格式如：张三+电话', trigger: 'blur' }
                ],
                signa_time: [
                    { required: true, type: 'array', min: 1,  message: '请选择合同有效期', trigger: 'change' }
                ]
            }
        }
    },
    methods: {
        /**
         功能：图片文件
         time: 2025/12/17 10:48
         **/
        FileDelete(){
            let that = this;
            that.Forms.contract_file = "";
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        handleSuccess(res){
            let that = this;
            if(res.code === 100){
                this.Forms.contract_file = res.data.url;
            }else{
                that.$Message.error({ background: true,duration:3, content: res.msg});
            }
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        handleFormatError(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '只支持 xls | xlsx | rar | zip | doc | docx | txt | jpg | jpeg | png 文件 ' });
            return false;
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        handleMaxSize(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '文件大小不能超出 50M' });
            return false;
        },
        /**
         功能：
         time: 2025/12/19 18:12
         **/
        FileDownload(){
            let that = this;
            if(that.Forms.contract_file){
                //下载文件
                const fileUrl = that.site_url + that.Forms.contract_file; // 文件的URL地址
                const parts = fileUrl.split('/');
                const fileName = parts[parts.length - 1];
                const link = document.createElement('a');
                link.href = fileUrl;
                link.setAttribute('download', fileName);
                link.click();
            }else{
                that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
            }
        },
        /**
         功能：
         time: 2025/12/17 16:04
         **/
        GetDetail(project_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getProjectContentDetail(project_id).then(e => {
                let re = e.data;
                that.Forms.contract_money = re.contract_money ? re.contract_money : '';
                that.Forms.money = re.money ? re.money : '';
                that.Forms.contract_signa_name = re.contract_signa_name ? re.contract_signa_name : '';
                that.Forms.signa_time = re.signa_time ? re.signa_time : [];
                that.Forms.contract_file = re.contract_file ? re.contract_file : '';
                that.Forms.remark = re.remark ? re.remark : '';
            })
        },
        /**
         功能：
         time: 2025/12/17 10:47
         **/
        show(project_id, name){
            this.isBox = true;
            this.title = name + ' - 签订合同';
            if(project_id){
                this.Forms.project_id = project_id;
                this.GetDetail(project_id);
            }
        },
        /**
         功能：
         time: 2025/12/20 09:24
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    contractProject(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2025/12/20 11:54
         **/
        FormReset(){
            this.isBox = false;
            this.title = '签订合同';
            this.$refs['Forms'].resetFields();
            this.Forms.project_id = '';
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
